<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre19" id="pgepubid00024">CONTENTS</h2>
<table class="calibre22" summary="CONTENTS">
<tbody class="calibre10"><tr class="calibre11">
<td class="calibre13" colspan="2"></td>
<td class="calibre13"><span class="smaller">PAGE</span></td>
</tr>
<tr class="calibre11">
<td class="left" colspan="2"><span class="smcap">Preface</span></td>
<td class="calibre13"><a href="#/Text/Section0002">v</a></td>
</tr>
<tr class="calibre11">
<td class="left" colspan="2"><span class="smaller">CHAPTER</span></td>
<td class="calibre13"></td>
</tr>
<tr class="calibre11">
<td class="calibre13">I.  </td>
<td class="left"><span class="smcap">Deportation To Russia</span></td>
<td class="calibre13"><a href="#/Text/Section0004">1</a></td>
</tr>
<tr class="calibre11">
<td class="calibre13">II.  </td>
<td class="left"><span class="smcap">Petrograd</span></td>
<td class="calibre13"><a href="#/Text/Section0005">11</a></td>
</tr>
<tr class="calibre11">
<td class="calibre13">III.  </td>
<td class="left"><span class="smcap">Disturbing Thoughts</span></td>
<td class="calibre13"><span href="#/Text/Section0006" title="Link target outside of Sample">22</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">IV.  </td>
<td class="left"><span class="smcap">Moscow: First Impressions</span></td>
<td class="calibre13"><span href="#/Text/Section0007" title="Link target outside of Sample">32</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">V.  </td>
<td class="left"><span class="smcap">Meeting People</span></td>
<td class="calibre13"><span href="#/Text/Section0008" title="Link target outside of Sample">46</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">VI.  </td>
<td class="left"><span class="smcap">Preparing for American Deportees</span></td>
<td class="calibre13"><span href="#/Text/Section0009" title="Link target outside of Sample">57</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">VII.  </td>
<td class="left"><span class="smcap">Rest Homes for Workers</span></td>
<td class="calibre13"><span href="#/Text/Section0010" title="Link target outside of Sample">67</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">VIII.  </td>
<td class="left"><span class="smcap">The First of May in Petrograd</span></td>
<td class="calibre13"><span href="#/Text/Section0011" title="Link target outside of Sample">74</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">IX.  </td>
<td class="left"><span class="smcap">Industrial Militarization</span></td>
<td class="calibre13"><span href="#/Text/Section0012" title="Link target outside of Sample">79</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">X.  </td>
<td class="left"><span class="smcap">The British Labour Mission</span></td>
<td class="calibre13"><span href="#/Text/Section0013" title="Link target outside of Sample">90</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XI.  </td>
<td class="left"><span class="smcap">A Visit from the Ukraina</span></td>
<td class="calibre13"><span href="#/Text/Section0014" title="Link target outside of Sample">94</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XII.  </td>
<td class="left"><span class="smcap">Beneath the Surface</span></td>
<td class="calibre13"><span href="#/Text/Section0015" title="Link target outside of Sample">107</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XIII.  </td>
<td class="left"><span class="smcap">Joining the Museum of the Revolution</span></td>
<td class="calibre13"><span href="#/Text/Section0016" title="Link target outside of Sample">118</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XIV.  </td>
<td class="left"><span class="smcap">Petropavlovsk and Schlüsselburg</span></td>
<td class="calibre13"><span href="#/Text/Section0017" title="Link target outside of Sample">126</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13"><span id="pgepubid00025" title="[Pg xxii]"><a id="Page_xxii" title="[Pg xxii]"></a></span>XV.  </td>
<td class="left"><span class="smcap">The Trade Unions</span></td>
<td class="calibre13"><span href="#/Text/Section0018" title="Link target outside of Sample">132</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XVI.  </td>
<td class="left"><span class="smcap">Maria Spiridonova</span></td>
<td class="calibre13"><span href="#/Text/Section0019" title="Link target outside of Sample">141</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XVII.  </td>
<td class="left"><span class="smcap">Another Visit to Peter Kropotkin</span></td>
<td class="calibre13"><span href="#/Text/Section0020" title="Link target outside of Sample">153</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XVIII.  </td>
<td class="left"><span class="smcap">En Route</span></td>
<td class="calibre13"><span href="#/Text/Section0021" title="Link target outside of Sample">160</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XIX.  </td>
<td class="left"><span class="smcap">In Kharkov</span></td>
<td class="calibre13"><span href="#/Text/Section0022" title="Link target outside of Sample">166</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XX.  </td>
<td class="left"><span class="smcap">Poltava</span></td>
<td class="calibre13"><span href="#/Text/Section0023" title="Link target outside of Sample">194</span></td>
</tr>
<tr class="calibre11">
<td class="calibre13">XXI.  </td>
<td class="left"><span class="smcap">Kiev</span></td>
<td class="calibre13"><span href="#/Text/Section0024" title="Link target outside of Sample">211</span></td>
</tr>
</tbody>
</table>
<div class="calibre23" id="calibre_pb_3"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?6a200bfc